/**
 * @namespace Clipboard
 * @aka COMMON.Clipboard
 */
COMMON.Clipboard = function ($, ClipboardJS) {
  /**
   * ------------------------------------------------------------------------
   * Constants
   * ------------------------------------------------------------------------
   */

  var NAME = 'clipboard';
  var DATA_KEY = 'common.' + NAME;
  var EVENT_KEY = '.' + DATA_KEY;
  var DATA_API_KEY = '.data-api';
  var JQUERY_NO_CONFLICT = $.fn[NAME];

  var Event = {
    PJAX_DATA_API: 'pjax:end' + EVENT_KEY + DATA_API_KEY + ' common.frequenzsuche.result'
  };
  var Selector = {
    DATA_SPY: '[data-spy="clipboard"]'
  };

  /**
   * ------------------------------------------------------------------------
   * Class Definition
   * ------------------------------------------------------------------------
   */
  var Clipboard = function () {

    function Clipboard(element) {
      var self = this;

      // protected
      self._element = element;
      self._$element = $(self._element);

      if (navigator.clipboard) {
        $(document).on('common:clipboard:bind-element', function (event, data){
          self._$element.off('click' + EVENT_KEY + DATA_API_KEY);
          data.$trigger.on('click' + EVENT_KEY + DATA_API_KEY, _bindClick);
        });

        self._$element.on('click' + EVENT_KEY + DATA_API_KEY, _bindClick);
      } else {
        //Wenn kein Clipboard unterstützt wird, wird der Button disabled
        self._$element.prop('disabled', 'disabled');
      }

      function _bindClick(event) {
        event.preventDefault();
        event.stopPropagation();
        console.log(this);

        copyToClipboard().then(result => {
          if(result !== -1) {
            //Success
            $(document).trigger('common:clipboard:success');
            COMMON.Toast.generateToast("success", "In Zwischenablage kopiert");
          } else {
            //Error
            self._$element.trigger('common:clipboard:error');
          }
        });
      }

      async function copyToClipboard() {
        var attribute;

        switch (self._element.nodeName) {
          case 'INPUT':
            // input[type=text]
            attribute = 'value';
            if (!self._element.hasAttribute(attribute)) {
              return -1;
            }
            break;
          case 'A':
            // a[href]
            attribute = 'href';
            if (!self._element.hasAttribute(attribute)) {
              return -1;
            }
            break;
          case 'BUTTON':
            // button
            attribute = 'data-clipboard-text';
            if (!self._element.hasAttribute(attribute)) {
              return -1;
            }
            break;
          default:
            return -1;
        }

        await navigator.clipboard.writeText(self._element.getAttribute(attribute));
        return 0;
      }
    }

    // public
    Clipboard.prototype.dispose = function dispose() {
      this._element = null;
      this.config = null;
      this.state = null;
    };

    // static
    Clipboard._jQueryInterface = function _jQueryInterface() {
      return this.each(function () {
        var data = $(this).data(DATA_KEY);

        if (!data) {
          data = new Clipboard(this);
          $(this).data(DATA_KEY, data);
        }
      });
    };

    return Clipboard;
  }();

  /**
   * ------------------------------------------------------------------------
   * Data Api implementation
   * ------------------------------------------------------------------------
   */
  $(Selector.DATA_SPY).each(function () {
    var $element = $(this);
    Clipboard._jQueryInterface.call($element, $element.data());
  });

  $(document).on(Event.PJAX_DATA_API, function (event, xhr, options) {
    $(options.container).find(Selector.DATA_SPY).each(function () {
      var $element = $(this);
      Clipboard._jQueryInterface.call($element, $element.data());
    });
  });

  /**
   * ------------------------------------------------------------------------
   * jQuery
   * ------------------------------------------------------------------------
   */
  $.fn[NAME] = Clipboard._jQueryInterface;
  $.fn[NAME].Constructor = Clipboard;
  $.fn[NAME].noConflict = function () {
    $.fn[NAME] = JQUERY_NO_CONFLICT;
    return Clipboard._jQueryInterface;
  };

  return Clipboard;

}(window.jQuery, window.ClipboardJS);
